import { COLORS } from '@collections/colors'

const MuiSelect = {
  styleOverrides: {
    select: {
      width: '145px',
      height: '36px',
      padding: '5px 12px',
      border: `1px solid ${COLORS.borderGray}`,
      fontSize: '13px',
      borderRadius: '10px'
    },
    root: {
      border: 'none',

      fieldset: {
        border: 0
      }
    }
  }
}

export default MuiSelect
